"use client";

import styled, { css } from "styled-components";

export const TableContentsWrapper = styled.div<{
  $containerDirection: "left" | "right" | "both";
}>`
  display: flex;
  flex-direction: row;
  gap: 3.2rem;
  width: 100%;

  .article-detail-tablet-ui-true & {
    display: flex;
  }

  ${({ $containerDirection }) => {
    if ($containerDirection === "left") {
      return css`
        justify-content: flex-start;
      `;
    }
    if ($containerDirection === "right") {
      return css`
        justify-content: flex-end;
      `;
    }
    return css`
      justify-content: space-between;
    `;
  }}
`;

export const TableGroupWrapper = styled.div<{ $isArrowVisible: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;

  gap: 0;
  width: calc(50% - 1.6rem);
  height: fit-content;

  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  background: #f8f9fa;
  padding: var(--Spacing-0, 0rem) var(--Spacing-16, 1.6rem)
    var(--Spacing-16, 1.6rem) var(--Spacing-16, 1.6rem);

  ${({ $isArrowVisible }) =>
    $isArrowVisible &&
    css`
      min-height: 24rem;
    `}
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  flex: 1;
  width: 100%;
  height: fit-content;

  .item-in-row-true {
    border-top: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
  }

  .item-in-row-false {
    border-bottom: 0;
  }
  .border-bottom-none,
  .border-bottom-none-true {
    border-bottom: 0;
  }

  .existed-value-text-false {
    display: none;
  }

  .item-in-row-count-1 {
    .existed-value-text-true {
      &.existed-value-text-0 {
        border-right: 0;
      }
    }
  }
`;

export const ArrowContainer = styled.div`
  position: absolute;
  top: 0;
  left: -3.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 100%;
  z-index: 1;
`;
